import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

import {Destroyable} from '../../../destroyable.component';
import {DateLocalizationPipe} from '../../pipes/date-localization.pipe';
import {PersonDataDTO} from '../sdconnect.model';

@Component({
  selector: 'gp-sdc-person-data-items',
  templateUrl: './sdc-person-data-items.component.html',
  styleUrls: ['./sdc-person-data-items.component.scss'],
  providers: [
    DateLocalizationPipe
  ]
})
export class SdcPersonDataItemsComponent extends Destroyable implements OnChanges {

  @Input()
  public standardFields: string[];

  @Input()
  public additionalFields: string[];

  @Input()
  public dated: boolean;

  @Input()
  public data: PersonDataDTO[];

  @Input()
  public expandAll: boolean;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['expandAll']) {
      this.data?.forEach(datum => datum.isExpanded = this.expandAll);
    }
  }
}

